import { takeLatest, put, all } from "redux-saga/effects";
import { push } from "connected-react-router";
import * as partnerAgreementTypes from "./types";

// TODO: WORKER SAGA: MAKES THE API CALL WHEN WATCHER SAGA SEES THE ACTION

/** go to success form */
function* goToSuccessForm(params) {
  yield put(push(params.payload));
}

//  TODO: SINGLE ENTRY POINT TO START ALL SAGAS AT ONCE
export default function* partnerAgreementRoutes() {
  yield all([
    yield takeLatest(
      partnerAgreementTypes.SUCCESS_FORM.WATCHER,
      goToSuccessForm
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/sagaRoute.js